import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 100%;
  gap: 0.4rem;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};

  span {
    font-size: 12px;
    color: #494949;
  }
`

export const Footer = styled.footer`
  display: flex;
  width: fit-content;
  align-self: flex-end;
`
